export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER (state, user) {
    state.user = user
    // console.log('Usuario = ' + user)
  },
  SET_TOKEN (state, token) {
    state.token = token
    // console.log('Token = ' + token)
  },
  SET_LANG (state, lang) {
    state.flag = lang
    // console.log('Token = ' + token)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js